import { useState } from 'react';
import Button, { ButtonProps } from 'src/ui/wards/common/button/Button';

type DetailsBarProps = {
  buttons: ButtonProps[];
  initialSelectedIndex: number;
  indexChanged: (index: number) => void;
};

function DetailsBar({ buttons, initialSelectedIndex, indexChanged }: DetailsBarProps) {
  const [currentIndex, setCurentIndex] = useState(initialSelectedIndex);
  return (
    <div className="mb-1 flex w-full border-b border-gray-200 pt-4">
      {buttons.map((item, index) => (
        <div key={item.key} className="flex-1 bg-gray-200 text-center">
          <Button
            onClick={() => {
              setCurentIndex(index);
              indexChanged(index);
            }}
            {...(item.title !== undefined && { title: item.title })}
            className="w-full bg-gray-200 p-2 text-gray-800"
          />
          {index === currentIndex && <div className="h-1 w-full bg-blue-400" />}
        </div>
      ))}
    </div>
  );
}

export default DetailsBar;
